
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { AppVideo } from 'appLanding/components/AppVideo';
import { KeyFeatures } from 'appLanding/components/KeyFeatures';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';

const AppLandingPage = () => (
  <>
    <AppVideo />
    <KeyFeatures />
  </>
);

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await setServerSideTranslations({ locale })),
    },
  };
};

export default AppLandingPage;
